export const PAYMENT = "PAYMENT";
export const FORM_FILING = "FORM_FILING";
export const W_SERIES = "W_SERIES";
export const REVIEW = "REVIEW";
export const UPLOAD_DOCUMENTS = "UPLOAD_DOCUMENTS";
export const FILING_IN_PROGRESS = "FILING_IN_PROGRESS";
export const SUBMITTED = "SUBMITTED";
export const TASK_AMENDMENT = "TASK_AMENDMENT";
export const TASK_AMENDMENT_COMPLETED = "TASK_AMENDMENT_COMPLETED";
export const TASK_DEFINING = "TASK_DEFINING";
export const TASK_AMENDMENT_DOCUMENTS = "TASK_AMENDMENT_DOCUMENTS";
